(function () {
    var root = document.documentElement;
    var STYLE_ID = 'ansukh-modal-theme';

    var PORTAL_BASE = [
        '.gh-portal-btn{transition:filter 0.2s ease,transform 0.2s ease,background-color 0.2s ease,border-color 0.2s ease,box-shadow 0.2s ease,opacity 0.2s ease!important;}',
        '.gh-portal-btn-link{background-color:transparent!important;border-color:transparent!important;text-decoration:underline!important;text-underline-offset:2px!important;font-weight:600!important;}',
        '.gh-portal-btn-link:hover{opacity:0.65!important;text-underline-offset:3px!important;}',
        '.gh-portal-btn-primary:hover{filter:brightness(0.9)!important;transform:translateY(-1px)!important;box-shadow:0 10px 22px rgba(0,0,0,0.22)!important;}',
        '.gh-portal-btn:not(.gh-portal-btn-primary):not(.gh-portal-btn-link):hover{filter:brightness(0.97)!important;transform:translateY(-1px)!important;}'
    ].join('');

    var PORTAL_LIGHT = [
        '.gh-portal-btn-link{color:#124e43!important;}',
        '.gh-portal-btn:not(.gh-portal-btn-primary):not(.gh-portal-btn-link){background-color:#ffffff!important;}'
    ].join('');

    var PORTAL_DARK = [
        '.gh-portal-popup-container,.gh-portal-content{background-color:#171e28!important;}',
        '.gh-portal-popup-container,.gh-portal-main-title,.gh-portal-content h1,.gh-portal-content h2,.gh-portal-content h3{color:#eaeef4!important;}',
        '.gh-portal-input-label,.gh-portal-content label,.gh-portal-signup-message,.gh-portal-signup-message span,.gh-portal-content p{color:#9aa6b4!important;}',
        '.gh-portal-input{background-color:#212b38!important;color:#ffffff!important;border-color:rgba(255,255,255,0.18)!important;}',
        '.gh-portal-btn:not(.gh-portal-btn-primary):not(.gh-portal-btn-link){background-color:#212b38!important;color:#eaeef4!important;border-color:rgba(255,255,255,0.18)!important;}',
        '.gh-portal-btn-link{color:#5fd6ba!important;}',
        '.gh-portal-closeicon{color:#9aa6b4!important;}',
        '.gh-portal-list,.gh-portal-list .gh-portal-list-detail{background-color:transparent!important;border-color:rgba(255,255,255,0.12)!important;}',
        '.gh-portal-list-clickable{border-color:rgba(255,255,255,0.12)!important;}',
        '.gh-portal-list-clickable:hover{background-color:rgba(255,255,255,0.05)!important;}',
        '.gh-portal-list-action{color:#5fd6ba!important;}',
        '.gh-portal-powered{background-color:transparent!important;}',
        '.gh-portal-powered a{background-color:#212b38!important;color:#9aa6b4!important;border-color:rgba(255,255,255,0.12)!important;}'
    ].join('');

    var SEARCH_BASE = '';
    var SEARCH_LIGHT = '';

    var SEARCH_DARK = [
        '.bg-white{background-color:#171e28!important;}',
        '.ghost-display{color:#eaeef4!important;}',
        'input{color:#ffffff!important;background-color:transparent!important;}',
        'input::placeholder{color:#7d8894!important;}',
        '.text-black,.text-neutral-900,.text-neutral-800,.text-neutral-700,.text-gray-900,.text-gray-800{color:#eaeef4!important;}',
        '.text-neutral-600,.text-neutral-500,.text-neutral-400,.text-gray-600,.text-gray-500,.text-gray-400{color:#9aa6b4!important;}',
        '.bg-neutral-100,.bg-neutral-50,.bg-gray-100,.bg-gray-50{background-color:#212b38!important;}',
        '[class*="border-neutral"],[class*="border-gray"]{border-color:rgba(255,255,255,0.1)!important;}'
    ].join('');

    function isDark() {
        return root.getAttribute('data-theme') === 'dark';
    }

    function composeCss(buckets) {
        return (buckets.base || '') + (isDark() ? (buckets.dark || '') : (buckets.light || ''));
    }

    function applyToFrame(iframe, buckets) {
        if (!iframe) {
            return;
        }

        var doc;
        try {
            doc = iframe.contentDocument;
        } catch (error) {
            return;
        }

        if (!doc || !doc.head) {
            return;
        }

        var scheme = isDark() ? 'dark' : '';

        if (doc.documentElement && doc.documentElement.style.colorScheme !== scheme) {
            doc.documentElement.style.colorScheme = scheme;
        }

        var css = composeCss(buckets);
        var style = doc.getElementById(STYLE_ID);

        if (css) {
            if (!style) {
                style = doc.createElement('style');
                style.id = STYLE_ID;
                doc.head.appendChild(style);
            }
            if (style.textContent !== css) {
                style.textContent = css;
            }
        } else if (style) {
            style.parentNode.removeChild(style);
        }
    }

    function themeFrame(iframe, buckets) {
        if (!iframe) {
            return;
        }

        applyToFrame(iframe, buckets);

        var attempts = 0;
        var timer = setInterval(function () {
            applyToFrame(iframe, buckets);
            if (++attempts > 100) {
                clearInterval(timer);
            }
        }, 120);

        iframe.addEventListener('load', function () {
            applyToFrame(iframe, buckets);

            var doc;

            try {
                doc = iframe.contentDocument;
            } catch (error) {
                return;
            }

            if (!doc) {
                return;
            }

            doc.addEventListener('readystatechange', function () {
                applyToFrame(iframe, buckets);
            });
        });
    }

    var watched = {};

    function watchRoot(rootId, buckets) {
        var el = document.getElementById(rootId);

        if (!el || watched[rootId]) {
            return;
        }

        watched[rootId] = true;

        var observer = new MutationObserver(function () {
            themeFrame(el.querySelector('iframe'), buckets);
        });
        observer.observe(el, {childList: true, subtree: true});

        themeFrame(el.querySelector('iframe'), buckets);
    }

    var PORTAL = {base: PORTAL_BASE, light: PORTAL_LIGHT, dark: PORTAL_DARK};
    var SEARCH = {base: SEARCH_BASE, light: SEARCH_LIGHT, dark: SEARCH_DARK};

    function discover() {
        watchRoot('ghost-portal-root', PORTAL);
        watchRoot('sodo-search-root', SEARCH);
    }

    function sync() {
        applyToFrame(document.querySelector('#ghost-portal-root iframe'), PORTAL);
        applyToFrame(document.querySelector('#sodo-search-root iframe'), SEARCH);
    }

    if (document.body) {
        new MutationObserver(discover).observe(document.body, {childList: true, subtree: true});
    }

    new MutationObserver(sync).observe(root, {attributes: true, attributeFilter: ['data-theme']});

    discover();
    sync();
})();
